import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=ebdf8488&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.vue?vue&type=style&index=0&id=ebdf8488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../ymoffers/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdf8488",
  null
  
)

export default component.exports